import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllInvoices, selectAllInvoices, selectInvoicesPager, updateInvoicesSearch } from "../redux/slices/publicSlice";
import moment from "moment";
import { formatTime } from "../utils/formatTime";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import Loader from "../components/Loader";
// import "../assets/public/css/bootstrap.min.css";

const Invoices = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allInvoices = useSelector(selectAllInvoices);
  const pager = useSelector(selectInvoicesPager);
  const [loading, setloading] = useState(true);
  const searchRef = useRef(null);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("");

  const onSearchChangeHandler = useCallback(
    debounce((searchValue) => {
      if (searchValue === "") {
        dispatch(updateInvoicesSearch(""));  // Resetting search value
        dispatch(getAllInvoices({ page: 1, sortType, setloading }));
      } else {
        dispatch(updateInvoicesSearch(searchValue));
        dispatch(getAllInvoices({ page: 1, sortType, setloading }));
      }
    }, 250),
    [sortType, setloading]
  );
  

  useEffect(() => {
    setloading(true);
    dispatch(getAllInvoices({ page: 1, sortType, setloading }));
  }, [sortType]);

  return (
    <>
      <Helmet>
        <title>Invoices - LightningProxies</title>
      </Helmet>

      <div class="page-body-wrapper">
        <div class="row text-start">
          <div class="col-12 col-md-7 col-xl-6">
            <div class="header-title">
              <h1>Your Invoices</h1>
              <p>Detailed list of all your invoices</p>
            </div>
          </div>
          <div class="col-12 col-md-5 col-xl-6">
            <div class="header-bttn">
              <p>
                Need Support?{" "}
                <a href="https://t.me/lightningproxies">
                  Contact Us <i class="fa fa-angle-right"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : allInvoices && allInvoices.length === 0 && search.length === 0 ? (
          <div class="row">
            <div class="col-12">
              <div class="dashboard-empty-box mt-15">
                <img src="./assets/images/no-invoice.svg" alt="Empty Image" class="img-fluid d-light" />
                <img src="./assets/images/no-invoice-dark.svg" alt="Empty Image" class="img-fluid d-dark" />
                <p>
                  No Invoices{" "}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div class="row">
            <div class="col-12">
              <div class=" active-plan-table mt-15 invoice-list-table overflow-auto">
                <div class="search-box d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-center">
                  <div class="form-group w-100">
                    <i class="fa fa-search"></i>
                    <input
                      value={search}
                      defaultValue={""}
                      ref={searchRef}
                      type="text"
                      placeholder="Search your invoices"
                      class="form-control invoice-input"
                      onChange={(e) => {
                        setSearch(e.target.value);
                        onSearchChangeHandler(e.target.value);
                      }}
                    />
                  </div>
                  <div class="sort text-nowrap">
                    <p>Sort by Payment :</p>
                    <ul>
                      <li className="d-light">
                        <a
                          href="#"
                          className={sortType === "unpaid" ? "border border-danger" : ""}
                          onClick={() => setSortType("unpaid")}
                        >
                          <i class="fa fa-circle text-danger"></i> Unpaid
                        </a>
                      </li>
                      <li className="d-dark ">
                        <a
                          href="#"
                          className={sortType === "unpaid" ? "border border-danger" : ""}
                          onClick={() => setSortType("unpaid")}
                          style={{ color: "white" }}
                        >
                          <i class="fa fa-circle text-danger"></i> Unpaid
                        </a>
                      </li>
                      <li className="d-dark">
                        <a
                          href="#"
                          className={sortType === "paid" ? "grn border border-success" : "grn"}
                          onClick={() => setSortType("paid")}
                          style={{ color: "white" }}
                        >
                          <i class="fa fa-circle "></i> Paid
                        </a>
                      </li>
                      <li className="d-light">
                        <a
                          href="#"
                          className={sortType === "paid" ? "grn border border-success" : "grn"}
                          onClick={() => setSortType("paid")}
                        >
                          <i class="fa fa-circle "></i> Paid
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <table>
                  <tr>
                    <th>INVOICE ID</th>
                    <th>PLAN</th>
                    <th>STATUS</th>
                    <th>TYPE</th>
                    <th>PAYMENT STATUS</th>
                    <th>AMOUNT</th>
                    <th>BANDWIDTH</th>
                    <th>PROCESSOR</th>
                    <th>DATE & TIME</th>
                    <th>ACTIONS</th>
                  </tr>

                  {allInvoices.map((invoice, index) => {
                    return (
                      <>
                        <tr>
                          <td>{invoice._id}</td>
                          <td>
                            {invoice.trial && "[Trial]"} {invoice.planName}
                          </td>
                          <td className="text-nowrap">
                            {invoice.topup === true && (
                              <>
                                {invoice.unresolvedStatus == null && invoice.paid && (
                                  <span className="bg-success bg-opacity-10" style={{ color: "var(--bs-green)" }}>
                                    Paid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                                  <span className="bg-danger bg-opacity-10" style={{ color: "var(--bs-danger)" }}>
                                    Unpaid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                                  <span className="bg-info bg-opacity-10" style={{ color: "var(--bs-info)" }}>
                                    Pending
                                  </span>
                                )}
                                {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                                  <>
                                    <span
                                      className="bg-warning bg-opacity-10"
                                      style={{
                                        color: "var(--bs-warning)",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {invoice.unresolvedStatus.toLowerCase()}
                                    </span>
                                  </>
                                )}
                              </>
                            )}
                            {/* Renewal */}
                            {invoice.renew === true && (
                              <>
                                {invoice.unresolvedStatus == null && invoice.paid && (
                                  <span className="bg-success bg-opacity-10" style={{ color: "var(--bs-green)" }}>
                                    Renewed
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                                  <span className="bg-danger bg-opacity-10" style={{ color: "var(--bs-danger)" }}>
                                    Unpaid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                                  <span className="bg-info bg-opacity-10" style={{ color: "var(--bs-info)" }}>
                                    Pending
                                  </span>
                                )}
                                {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                                  <>
                                    <span
                                      className="bg-warning bg-opacity-10"
                                      style={{
                                        color: "var(--bs-warning)",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {invoice.unresolvedStatus.toLowerCase()}
                                    </span>
                                  </>
                                )}
                              </>
                            )}

                            {/* Subscription with renewal data */}
                            {invoice.renew === false &&
                              invoice.topup === false &&
                              Object.keys(invoice).includes("renewalDate") &&
                              invoice.renewalDate && (
                                <>
                                  {moment(invoice?.renewalDate).diff(moment().utc(), "seconds") > 0 ? (
                                    <span className="text-primary  bg-primary bg-opacity-10 text-nowrap">
                                      Ends in{" "}
                                      {moment.duration(moment(invoice?.renewalDate).diff(moment().utc(), "seconds") * 1000).humanize()}
                                    </span>
                                  ) : (
                                    <span className="bg-danger bg-opacity-10" style={{ color: "var(--bs-danger)" }}>
                                      Expired
                                    </span>
                                  )}
                                </>
                              )}

                            {/* Subscription without renewal data */}
                            {invoice.renew === false && invoice.topup === false && !Object.keys(invoice).includes("renewalDate") && (
                              <>
                                {invoice.unresolvedStatus == null && invoice.paid && (
                                  <span
                                    className="bg-danger bg-opacity-10"
                                    style={{
                                      color: "var(--bs-danger)",
                                    }}
                                  >
                                    Not Activated
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                                  <span
                                    className="bg-danger bg-opacity-10"
                                    style={{
                                      color: "var(--bs-danger)",
                                    }}
                                  >
                                    Unpaid
                                  </span>
                                )}
                                {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                                  <span className="bg-info bg-opacity-10" style={{ color: "var(--bs-info)" }}>
                                    Pending
                                  </span>
                                )}
                                {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                                  <>
                                    <span
                                      className="bg-warning bg-opacity-10"
                                      style={{
                                        color: "var(--bs-warning)",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {invoice.unresolvedStatus.toLowerCase()}
                                    </span>
                                  </>
                                )}
                              </>
                            )}
                          </td>
                          <td>{invoice.type}</td>
                          <td>
                            {invoice.unresolvedStatus == null && invoice.paid && (
                              <>
                                {/* <span className="legend-indicator bg-success" /> */}
                                <span className="bg-success bg-opacity-10 ">
                                  <i style={{ color: "rgba(0, 166, 17, 1)" }} class="fa fa-circle"></i>
                                  Paid
                                </span>
                              </>
                            )}
                            {invoice.unresolvedStatus == null && !invoice.paid && !invoice.pending && (
                              <>
                                {/* <span className="legend-indicator bg-danger" /> */}
                                <span className="bg-danger bg-opacity-10">
                                  <i class="fa fa-circle text-danger"></i>
                                  Unpaid
                                </span>
                              </>
                            )}
                            {invoice.unresolvedStatus == null && !invoice.paid && invoice.pending && (
                              <>
                                {/* <span className="legend-indicator bg-info" /> */}
                                <span className="bg-info bg-opacity-10">
                                  <i class="fa fa-circle text-info"></i>
                                  Pending
                                </span>
                              </>
                            )}
                            {!invoice.paid && !invoice.pending && invoice.unresolvedStatus != null && (
                              <>
                                {/* <span className="legend-indicator bg-warning" /> */}
                                <span
                                  className="bg-warning bg-opacity-10"
                                  style={{
                                    color: "var(--bs-warning)",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  <i class="fa fa-circle text-warning"></i>
                                  {invoice.unresolvedStatus.toLowerCase()}
                                </span>
                              </>
                            )}
                          </td>
                          <td className="fw-bolder">${invoice.price?.toFixed(2)}</td>
                          <td>
                            {invoice.topup === false &&
                              (invoice.renew === true
                                ? invoice.bandwidth
                                  ? `${invoice.bandwidth} GB`
                                  : "Unlimited"
                                : invoice.bandwidth !== 0
                                ? `${invoice.bandwidth} GB`
                                : "Unlimited")}
                            {invoice.topup === true && "-"}
                          </td>
                          <td>{invoice.paymentProcessor.toUpperCase()}</td>
                          <td>{formatTime(invoice.createdAt)}</td>
                          <td>
                            {invoice.invoiceLink ? (
                              <a
                                onClick={() => {
                                  window.open(invoice.invoiceLink, "_blank");
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                View <i class="fa fa-angle-right"></i>
                              </a>
                            ) : (
                              <>-</>
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </table>
                {pager?.total > 1 && (
                  <div
                    className="container"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 20,
                      border: "solid",
                      borderWidth: "0px",
                      borderTopWidth: "0.1px",
                      borderColor: "var(--bs-gray-300)",
                    }}
                  >
                    <nav>
                      <ul class="pagination" style={{ margin: 0 }}>
                        <li
                          class="page-item"
                          style={{
                            margin: "0px",
                            // border: "solid",
                            paddingTop: "2px",
                            // borderWidth: "0.2px",
                            borderColor: "var(--bs-gray-400)",
                            borderTopLeftRadius: 6,
                            borderBottomLeftRadius: 6,
                          }}
                          onClick={() => {
                            dispatch(
                              getAllInvoices({
                                page: pager.page <= 1 ? 1 : pager.page - 1,
                              })
                            );
                          }}
                        >
                          <a class="page-link  bg-transparent" href="#" aria-label="Previous">
                            <span aria-hidden="true" style={{ fontSize: "1.3rem" }}>
                              &laquo;
                            </span>
                          </a>
                        </li>

                        <li
                          class="page-item"
                          style={{
                            padding: 15,
                            display: "flex",
                            alignItems: "center",
                            margin: "0px",
                            // border: "solid",
                            // borderWidth: "0px",
                            // borderBottomWidth: "0.2px",
                            // borderTopWidth: "0.2px",
                            borderColor: "var(--bs-gray-400)",
                          }}
                        >
                          {pager?.page} of {pager?.total}
                        </li>

                        <li
                          class="page-item"
                          style={{
                            margin: "0px",
                            // border: "solid",
                            paddingTop: "2px",
                            // borderWidth: "0.2px",
                            borderColor: "var(--bs-gray-400)",
                            borderTopRightRadius: 6,
                            borderBottomRightRadius: 6,
                          }}
                          onClick={() => {
                            dispatch(
                              getAllInvoices({
                                page: pager.page >= pager.total ? pager.total : pager.page + 1,
                              })
                            );
                          }}
                        >
                          <a class="page-link bg-transparent" href="#" aria-label="Next">
                            <span aria-hidden="true" style={{ fontSize: "1.3rem" }}>
                              &raquo;
                            </span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Invoices;
